import { gql, useMutation } from "@apollo/client";
import { NormalizedErrorMap } from "../../../types/NormalizedErrorMap";
import React, { ReactElement } from "react";
import { 
  CreateLocationMutationMutation, 
  CreateLocationMutationMutationVariables 
} from "../../../schemaTypes";
import { normalizeErrors } from "../../../utils/normalizeErrors";

export const createLocationMutation = gql`
  mutation CreateLocationMutation(
    $input: CreateLocationInput
  ) {
    createLocation(
      input: $input
    ) {
      errors {
        path
        message
      }
      message
    }
  }
`;

interface Props {
  children: (
    data: {
      submitCreateLocation: (
        values: CreateLocationMutationMutationVariables
      ) => Promise<NormalizedErrorMap | any>;
      loading: boolean;
      error: any;
      message: string | null;
      createLocationData: any | null; 
    }
  ) => ReactElement | null;
}

export const CreateLocationController: React.FC<Props> = ({ children }) => {
  const [mutate, { loading, error, data }] = useMutation<
    CreateLocationMutationMutation,
    CreateLocationMutationMutationVariables
  >(createLocationMutation);

  const submitCreateLocation = async (values: CreateLocationMutationMutationVariables) => {
    const { data: {createLocation} }:any = await mutate({ variables: values });

    if (createLocation?.errors) {
      return {error: normalizeErrors(createLocation.errors), createLocation: null};
    }

    return {
      error: null,
      createLocation
    };
  };

  const message = data?.createLocation?.message || null;

  return children({
    submitCreateLocation,
    loading,
    error,
    message,
    createLocationData: data,
  });
};